// extracted by mini-css-extract-plugin
export default {"maincontainer":"User_maincontainer__wWxwV","header":"User_header__fpxqp","btn_color":"User_btn_color__ev9gt","btn_colordis":"User_btn_colordis__2Fw8U","holder":"User_holder__0tN3d"};